//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addObj } from "@/api/admin/dict";
export default {
  props: {
    addData: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: function data() {
    return {
      subDisabled: false,
      formValidate: {
        id: null,
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      },
      // 表单数据绑定
      ruleValidate: {
        type: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }],
        remarks: [{
          required: false,
          message: "",
          trigger: "blur"
        }, {
          min: 1,
          max: 200,
          message: "长度在 1 到 200 个字符",
          trigger: "blur"
        }]
      } // 表单验证

    };
  },
  computed: {},
  methods: {
    closeModal: function closeModal() {
      var _this = this;

      this.$emit("closeAdd", {
        state: false
      });
      this.addData.state = false;
      setTimeout(function () {
        _this.$refs["ruleForm"].resetFields();

        _this.formValidate.remarks = "";
      }, 200);
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.subDisabled = true;
          addObj(_this2.formValidate).then(function (res) {
            if (res.data.code == 0) {
              _this2.subDisabled = false;

              _this2.$refs[formName].resetFields();

              _this2.closeModal();
            } else {
              _this2.subDisabled = false;

              _this2.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.formValidate = {
        id: null,
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      };
      this.$refs[formName].resetFields();
    }
  }
};